import { useState } from "react"

export const useGlobalStates = () => {
    
    const [ showForm, setShowForm ] = useState(false)
    const [ formOpeningMode, setFormOpeningMode ] = useState('EDITABLE')
    const [ loadingSubmitForm, setloadingSubmitForm ] = useState(false)

    return Object.freeze({
        showForm, setShowForm,
        formOpeningMode, setFormOpeningMode,
        loadingSubmitForm, setloadingSubmitForm
    })
}